// Horizontal tabs bar for the platform admin. Left-anchored, overflow-scroll
// on small viewports so it stays one line without collision.
import React from 'react';
import { Building2, Mail, Rocket, KeyRound, MonitorSmartphone, Activity, DollarSign, ShieldAlert } from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { key: 'centers',   label: 'All Centers', icon: Building2 },
  { key: 'demos',     label: 'Demos',       icon: Rocket },
  { key: 'signins',   label: 'Sign-ins',    icon: KeyRound },
  { key: 'devices',   label: 'Devices',     icon: MonitorSmartphone },
  { key: 'activity',  label: 'Activity',    icon: Activity },
  { key: 'spend',     label: 'AI spend',    icon: DollarSign },
  { key: 'security',  label: 'Security',    icon: ShieldAlert },
  { key: 'invite',    label: 'Send Invite', icon: Mail },
];

export default function AdminTabs({ active, onChange, badges = {} }) {
  return (
    <div className="mt-6 flex items-center gap-1 overflow-x-auto border-b border-slate-200 pb-0.5" data-testid="admin-tabs">
      {TABS.map(({ key, label, icon: Icon }) => {
        const on = active === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            data-testid={`admin-tab-${key}`}
            className={cn(
              'group inline-flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors',
              on
                ? 'border-slate-900 text-slate-900'
                : 'border-transparent text-slate-500 hover:text-slate-800',
            )}
          >
            <Icon className={cn('h-4 w-4', on ? 'text-slate-900' : 'text-slate-400 group-hover:text-slate-700')} />
            {label}
            {badges[key] > 0 && (
              <span className="ml-1 rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold text-amber-800">
                {badges[key]}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
